import $ from "jquery";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class CTATiles {
  $el = $("section.cta-tiles");

  constructor() {
    if (!this.$el.length) return;

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    this.setupCardAnimations();
    //this.setupAmplifyAnimation();
  }

  setupCardAnimations() {
    const elId = this.$el.attr("id");

    gsap.from("#" + elId + " .tile", {
      y: "+=100",
      opacity: 0,
      duration: 1,
      stagger: 0.2,

      scrollTrigger: {
        trigger: this.$el[0],
        start: "top bottom",
        end: "bottom 90%",
        scrub: 1,
        toggleActions: "play none none none",
        markers: false,
      },
    });
  }

  setupAmplifyAnimation() {
    const svg = this.$el.find(".background svg path")[0];

    gsap.to(svg, {
      attr: { d: "M1455,1441 L1458, 50, 0, 350 l8.68,1291 h1446Z" },
      ease: "none",
      scrollTrigger: {
        trigger: this.$el[0],
        start: "top bottom",
        end: "bottom top",
        scrub: 3,
        toggleActions: "play none none none",
        markers: false,
      },
    });
  }
}
